import styled from "styled-components";

import { PrimaryButton } from "components/Button";

export const DoneButton = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(14)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  width: 100%;
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(62)};
  margin-bottom: ${({ theme }) => theme.customTheme.pxToRem(62)};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.customTheme.pxToRem(64)} auto;
    max-width: 336px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 327px;
    margin: ${({ theme }) => theme.customTheme.pxToRem(88)} auto;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(26)};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(40)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(48)};
    margin: ${({ theme }) => theme.customTheme.pxToRem(96)} 0 0;
    text-align: center;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    text-align: left;
  }
`;

export const Description = styled.p`
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.grey.light5E};
  margin-top: ${({ theme }) => theme.customTheme.pxToRem(20)};
  margin-bottom: ${({ theme }) => theme.customTheme.pxToRem(48)};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin-bottom: ${({ theme }) => theme.customTheme.pxToRem(120)};
    margin-top: ${({ theme }) => theme.customTheme.pxToRem(16)};
    text-align: center;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    margin: ${({ theme }) => theme.customTheme.pxToRem(16)} 0 ${({ theme }) => theme.customTheme.pxToRem(64)};
    font-size: ${({ theme }) => theme.customTheme.pxToRem(20)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(24)};
    text-align: left;
  }
`;

export const MoreInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 375px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    max-width: 517px;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    max-width: 684px;
  }
`;
